import { Entity } from "../../common/entity";
import { DocumentationPageContentData } from "../../dsm";
import { PageBlockDefinition } from "../../dsm/documentation/block-definitions/definition";
import { PageSectionEditorModelV2 } from "../../dsm/elements/data/documentation-section-v2";
import { DocumentationPageV2 } from "../../dsm/elements/documentation-page-v2";
import { ElementGroup } from "../../dsm/elements/group";
import { PageBlockEditorModelV2 } from "../../dsm/elements/page-block-v2";
import { z } from "zod";
export const DocumentationPageRoom = Entity.extend({
    designSystemVersionId: z.string(),
    documentationPageId: z.string(),
    liveblocksId: z.string(),
    isDirty: z.boolean(),
});
//
// Room content
//
export const DocumentationPageRoomState = z.object({
    pageItems: z.array(PageBlockEditorModelV2.or(PageSectionEditorModelV2)),
});
export const DocumentationPageRoomRoomUpdate = z.object({
    page: DocumentationPageV2,
    pageParent: ElementGroup,
});
export const DocumentationPageRoomInitialStateUpdate = DocumentationPageRoomRoomUpdate.extend({
    pageItems: z.array(PageBlockEditorModelV2.or(PageSectionEditorModelV2)),
    blockDefinitions: z.array(PageBlockDefinition),
});
export const RestoredDocumentationPage = z.object({
    page: DocumentationPageV2,
    pageParent: ElementGroup,
    pageContent: DocumentationPageContentData,
    contentHash: z.string(),
});
export const RestoredDocumentationGroup = z.object({
    group: ElementGroup,
    parent: ElementGroup,
});
